import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Cta } from './Cta';
const stats: Array<{
  valor: string;
  etiqueta: string;
}> = [{
  valor: '6',
  etiqueta: 'Tomos completos'
}, {
  valor: '5',
  etiqueta: 'Bonos profesionales'
}, {
  valor: '300+',
  etiqueta: 'Recursos listos para usar'
}, {
  valor: '🌎',
  etiqueta: 'Países LATAM'
}];
export function Hero() {
  return <header className="w-full bg-canvas px-6 pb-16 pt-8 text-center" data-id="element-129" data-mp="129h2fs8fj8fj">
      <div className="mx-auto max-w-content" data-id="element-130" data-mp="128phdbcgkt3i">
        <p className="inline-flex rounded-full border border-brand-200 bg-brand-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-brand-700" style={{
        fontSize: "12px"
      }} data-id="element-131" data-mp="x9uqrn89208u">
           Sistema digital premium para manicuras · LATAM 2026 🌎
        </p>

        <h1 className="mx-auto mt-3 max-w-4xl font-display text-4xl font-bold leading-[1.08] text-ink sm:text-5xl lg:text-[3.75rem]" style={{
        fontSize: "32px",
        fontWeight: "700"
      }} data-id="element-132" data-mp="nekmesudpgrw">
          Mega Pack Manicuria sin esclavitud <span aria-hidden="true" data-id="element-133" data-mp="3j8se7xjcfdo9">💅</span>
        </h1>
        <p className="mx-auto mt-3 max-w-2xl font-display text-lg font-bold leading-snug text-brand-700 sm:text-2xl" style={{
        fontSize: "19px"
      }} data-id="element-134" data-mp="3j928hxbf86zr">
          6 tomos digitales + 5 bonos practicos para organizar tu negocio, cobrar mas y trabajar menos tiempo
        </p>

        <figure className="mx-auto mt-3 max-w-5xl" data-id="element-135" data-mp="3e8egp9fdbm4h">
          <img src="https://cdn.magicpatterns.com/uploads/vCQDGTtBnF27z4G9Cujd8z/imagen_mocakp_(1).png" alt="Combo completo del Mega Pack Manicuría Lista con sus 6 tomos y 5 bonos en PDF" className="mx-auto w-full max-w-3xl object-contain" width={1240} height={1240} data-id="element-136" data-mp="3eb9150ydt6xw" />
          <figcaption className="mt-4 font-display text-base font-bold text-brand-700 sm:text-lg" style={{
          fontSize: "18px"
        }} data-id="element-137" data-mp="2vi55xb5imm16">
            Más rapidez, más ganancias y CERO improvisación.
          </figcaption>
        </figure>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-body sm:text-lg" data-id="element-138" data-mp="2lk8wqow5215p">
          Implementá hoy mismo esta metodología para cobrar como una profesional y eliminar el
          agotamiento mental de tu negocio.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-muted" data-id="element-139" data-mp="ibyqgeyd5638">
          6 Tomos + 5 Bonos (300+ recursos) · Acceso inmediato vía PDF · Venta disponible en toda LATAM.
        </p>

        <div className="mt-9 flex flex-col items-center" data-id="element-140" data-mp="dbaq32o8vcwc">
          <Cta data-id="element-141" data-mp="1azkwdtv2cmt9">Obtener el acceso AHORA</Cta>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-142" data-mp="161t24t6y4olw">
            {['Cobrá lo que valés', 'Reducí tus tiempos', 'Cero estrés con clientas'].map(beneficio => <li key={beneficio} className="flex items-center gap-2 text-sm font-semibold text-body" data-id="element-143" data-mp="114kj6qdz4gjl">
                <CheckIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-144" data-mp="x3h0zx8ge8f7" />
                {beneficio}
              </li>)}
          </ul>
          <p className="mt-4 text-sm text-muted" data-id="element-145" data-mp="3hqkbsklh5wuf">
            Acceso inmediato · PDF descargable · Pago único · Sin suscripción
          </p>
          <p className="mt-2 text-sm font-medium text-brand-700" data-id="element-146" data-mp="1x7hvhcqqi10c">
            💱 La plataforma convierte automáticamente a tu moneda local
          </p>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-8 rounded-3xl border border-edge bg-surface px-8 py-10 sm:grid-cols-4" data-id="element-147" data-mp="268g3e64amso7">
          {stats.map(stat => <div key={stat.etiqueta} data-id="element-148" data-mp="2g0c1viaakksy">
              <dt className="sr-only" data-id="element-149" data-mp="2fzamx2q5ne5y">{stat.etiqueta}</dt>
              <dd data-id="element-150" data-mp="2kydtwspp3ugk">
                <span className="block font-display text-3xl font-bold text-brand-700" data-id="element-151" data-mp="2kxudjgfp1e4n">{stat.valor}</span>
                <span className="mt-1 block text-sm text-muted" data-id="element-152" data-mp="2p1sbhnta8iw4">{stat.etiqueta}</span>
              </dd>
            </div>)}
        </dl>

        <p className="mt-5 text-sm font-medium text-muted" data-id="element-153" data-mp="2tx7ka1cfnolo">
          ⭐⭐⭐⭐⭐ 4.9/5 · Más de 2.500 manicuristas ya lo usan en toda LATAM
        </p>
      </div>
    </header>;
}